import { createContext, useEffect, useState, useMemo } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ROUTE_NAME from '../utils/url-constants';
import { LoadingSpinner } from '@rabbit/elements/shared-components';
import { firebaseAuth } from '@rabbit/firebase/adapter-react';

// TODO: ADD A PROPER TYPE FOR USER!

interface UserInterface {
  user: any;
  handleSignout: () => void;
}

type UserProviderWrapperProps = {
  children: React.ReactNode;
};

const UserContext = createContext<UserInterface | null>(null);

const UserProviderWrapper = ({ children }: UserProviderWrapperProps) => {
  const [user, setUser] = useState(() => firebaseAuth.currentUser);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleSignout = () => {
    firebaseAuth.signOut();
    navigate('/auth');
  };

  const contextValues = useMemo(
    () => ({
      user,
      handleSignout,
    }),
    [user]
  );

  useEffect(() => {
    const start = () => {
      firebaseAuth.authStateReady().then(() => {
        setLoading(false);
      });
    };
    start();
  }, []);

  useEffect(() => {
    const unsubscribe = firebaseAuth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  if (loading) {
    return <LoadingSpinner size="md" isFullScreen />;
  }

  const NLIC_StopGetIdentity = window.localStorage.getItem(
    'NLIC_StopGetIdentity'
  );
  if (NLIC_StopGetIdentity) {
    return <Navigate to={ROUTE_NAME.NON_LOGGED_CONTINUE_CLAIM} />;
  }

  return (
    <UserContext.Provider value={contextValues}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProviderWrapper };
